function isMobile() {
  return (
    'ontouchstart' in document.documentElement
    && window.matchMedia('(any-pointer:coarse)').matches
  )
}

export const IS_MOBILE = isMobile()
